<template>
    <div class="cost-box">
        <HeaderNav
            header-title="生产成本"
            left-icon-name="2"
            right-icon-name="2"
            @change-org="handleChangeOrg"
        ></HeaderNav>
        <monthSelectTitle :tit="title" @change-month="changeMonth"></monthSelectTitle>
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                :formatter="formatter"
                :max-date="maxDate"
                @confirm="confirmMonth"
                @cancel="cancelMonth"
            ></van-datetime-picker>
        </van-popup>
        <div class="warpper">
            <div class="utit-cost">
                <div class="month-cost utit-cost-item">
                    <div class="money">
                        {{ monthData.total|toFixedNumber }}
                    </div>
                    <div class="label">
                        本月单位成本(元/方)
                    </div>
                </div>
                <div class="year-cost utit-cost-item">
                    <div class="money">
                        {{ yearData.total|toFixedNumber }}
                    </div>
                    <div class="label">
                        本年累计单位成本(元/方)
                    </div>
                </div>
            </div>
            <div class="split"></div>
            <h4 class="chart-title">
                <span>本月商砼单位成本构成</span>
                <span class="subtitle">单位(元/方)</span>
            </h4>
            <!-- 本月图表 -->
            <div id="monthPie"></div>
            <div class="split"></div>
            <h4 class="chart-title">
                <span>本年累计商砼单位成本构成</span>
                <span class="subtitle">单位(元/方)</span>
            </h4>
            <!-- 本年图表 -->
            <div id="yearPie"></div>
            <div class="btn-turn" @click="toCostDirectMaterials">
                <van-button type="info">
                    直接材料成本
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import monthSelectTitle from '@/components/header-nav/monthSelectTitle';
import utils from '@/assets/js/utils';
import { Dialog } from 'vant';
export default {
    components: {
        HeaderNav, monthSelectTitle,
    },
    data() {
        return {
            title: '', // 标题
            showCalendar: false, // 是否展示日历选择
            orgId: '', // 当前组织ID
            year: '', // 年
            month: '', // 月
            currentDate: new Date(),
            maxDate: '',
            monthData: {
                total: 0,
            },
            yearData: {
                total: 0,
            },
        };
    },
    methods: {
        drawMonthChart2() {
            let produceCost = 0;
            if (!this.monthData.produce) {
                this.monthData.produce = 0;
            } else {
                this.monthData.produce = parseFloat(this.monthData.produce.toFixed(2));
            }
            if (!this.monthData.water) {
                this.monthData.water = 0;
            } else {
                this.monthData.water = parseFloat(this.monthData.water.toFixed(2));
            }
            if (!this.monthData.power) {
                this.monthData.power = 0;
            } else {
                this.monthData.power = parseFloat(this.monthData.power.toFixed(2));
            }
            if (!this.monthData.person) {
                this.monthData.person = 0;
            } else {
                this.monthData.person = parseFloat(this.monthData.person.toFixed(2));
            }
            if (!this.monthData.direct) {
                this.monthData.direct = 0;
            } else {
                this.monthData.direct = parseFloat(this.monthData.direct.toFixed(2));
            }
            produceCost = parseFloat((this.monthData.produce + this.monthData.water + this.monthData.power).toFixed(2));
            const data = [
                { value: this.monthData.direct, name: '直接材料 ' },
                { value: this.monthData.person, name: '直接人工 ' },
                { value: produceCost, name: '制造费用 ' },
            ];
            let data2 = [
                { value: this.monthData.water, name: '水 ' + this.monthData.water },
                { value: this.monthData.power, name: '电 ' + this.monthData.power },
                { value: this.monthData.produce, name: '其他费用 ' + this.monthData.produce },
            ];
            this.monthData.details.map(item => {
                if (!item.value) {
                    item.value = 0;
                } else {
                    item.value = parseFloat(item.value.toFixed(2));
                }
                if (item.name === '其他') {
                    item.name = '其他材料';
                }
                item.name = item.name + ' ' + item.value;
            });
            data2 = this.monthData.details.concat(data2);
            let legendData = [
                { name: '水 ' + this.monthData.water },
                { name: '电 ' + this.monthData.power },
                { name: '其他费用 ' + this.monthData.produce },
            ];
            const legendDetail = this.monthData.details.map(item => {
                const json = { name: '' };
                json.name = item.name;
                return json;
            });
            legendData = legendDetail.concat(legendData);
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('monthPie'));
            const option = {
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: '1%',
                    align: 'left',
                    top: 'middle',
                    height: 200,
                    show: true,
                    data: legendData,
                },
                tooltip: {
                    trigger: 'item',
                    // formatter: function (params, ticket, callback) {
                    //     const str = params.name.split(' ')[0] + '：' + params.value;
                    //     return str;
                    // },
                    formatter: '{b}({c}%)',
                },
                series: [
                    {
                        type: 'pie',
                        data: data,
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}:{c}',
                        },
                        radius: [0, '40%'],
                        center: ['30%', '50%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#FFFFFF',
                        },
                        clockwise: true,
                        animation: false,
                        color: ['#0ea9ec', '#11c665', '#ffb204'],
                    },
                    {
                        type: 'pie',
                        data: data2,
                        label: {
                            show: false,
                        },
                        radius: ['45%', '60%'],
                        center: ['30%', '50%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#FFFFFF',
                        },
                        animation: false,
                        color: [ '#0682a6', '#339abd', '#5ab4d9', '#70caed', '#8eddfb', '#bdecff', '#d7f2fd',
                            '#3ec090', '#5eddaa', '#f2a847', '#f9c754', '#fde561'],
                    },
                ],
                backgroundColor: '#FFFFFF',
            };
            myChart.setOption(option, true);
        },
        drawYearChart() {
            let produceCost = 0;
            if (!this.yearData.produce) {
                this.yearData.produce = 0;
            } else {
                this.yearData.produce = parseFloat(this.yearData.produce.toFixed(2));
            }
            if (!this.yearData.water) {
                this.yearData.water = 0;
            } else {
                this.yearData.water = parseFloat(this.yearData.water.toFixed(2));
            }
            if (!this.yearData.power) {
                this.yearData.power = 0;
            } else {
                this.yearData.power = parseFloat(this.yearData.power.toFixed(2));
            }
            if (!this.yearData.person) {
                this.yearData.person = 0;
            } else {
                this.yearData.person = parseFloat(this.yearData.person.toFixed(2));
            }
            if (!this.yearData.direct) {
                this.yearData.direct = 0;
            } else {
                this.yearData.direct = parseFloat(this.yearData.direct.toFixed(2));
            }
            produceCost = parseFloat((this.yearData.produce + this.yearData.water + this.yearData.power).toFixed(2));
            const data = [
                { value: this.yearData.direct, name: '直接材料' },
                { value: this.yearData.person, name: '直接人工 ' },
                { value: produceCost, name: '制造费用 ' },
            ];
            let data2 = [
                { value: this.yearData.water, name: '水 ' + this.yearData.water },
                { value: this.yearData.power, name: '电 ' + this.yearData.power },
                { value: this.yearData.produce, name: '其他费用 ' + this.yearData.produce },
            ];
            this.yearData.details.map(item => {
                if (!item.value) {
                    item.value = 0;
                } else {
                    item.value = parseFloat(item.value.toFixed(2));
                }
                if (item.name === '其他') {
                    item.name = '其他材料';
                }
                item.name = item.name + ' ' + item.value;
            });
            data2 = this.yearData.details.concat(data2);
            let legendData = [
                { name: '水 ' + this.yearData.water },
                { name: '电 ' + this.yearData.power },
                { name: '其他费用 ' + this.yearData.produce },
            ];
            const legendDetail = this.yearData.details.map(item => {
                const json = { name: '' };
                json.name = item.name;
                return json;
            });
            legendData = legendDetail.concat(legendData);
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('yearPie'));
            // 指定图表的配置项和数据
            const option = {
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: '1%',
                    align: 'left',
                    top: 'middle',
                    height: 200,
                    show: true,
                    data: legendData,
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function (params, ticket, callback) {
                        const str = params.name.split(' ')[0] + '：' + params.value;
                        return str;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        data: data,
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}:{c}',
                        },
                        radius: [0, '40%'],
                        center: ['30%', '50%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#FFFFFF',
                        },
                        clockwise: true,
                        animation: false,
                        color: ['#0ea9ec', '#11c665', '#ffb204'],
                    },
                    {
                        type: 'pie',
                        data: data2,
                        label: {
                            show: false,
                        },
                        radius: ['45%', '60%'],
                        center: ['30%', '50%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#FFFFFF',
                        },
                        animation: false,
                        color: ['#0682a6', '#339abd', '#5ab4d9', '#70caed', '#8eddfb', '#bdecff', '#d7f2fd',
                            '#3ec090', '#5eddaa', '#f2a847', '#f9c754', '#fde561'],
                    },
                ],
                backgroundColor: '#FFFFFF',
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        // 切换运营区
        handleChangeOrg(value) {
            this.orgId = value;
            this.getCostsInfo();
        },
        // 按月下来筛选
        changeMonth() {
            this.showCalendar = true;
        },
        // 时间格式化
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        // 返回的时间格式化
        formatDate(date) {
            return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        },
        // 时间选择完成
        confirmMonth(value) {
            const timeStr = this.formatDate(value);
            const timeArr = timeStr.split('/');
            // eslint-disable-next-line radix
            this.year = parseInt(timeArr[0]);
            // eslint-disable-next-line radix
            this.month = parseInt(timeArr[1]);
            this.showCalendar = false;
            this.title = this.year + '年' + this.month + '月份，中国联合水泥商混生产成本情况';
            this.getCostsInfo();
        },
        // 取消时间选择
        cancelMonth() {
            this.showCalendar = false;
        },
        // 获取生产成本信息
        getCostsInfo() {
            this.$axios
                .get('/interfaceApi/report/CostsManager/get_costs_info/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        const wages = res.Month.details.shift();
                        const welfare = res.Month.details.shift();
                        res.Month.details.push(wages);
                        res.Month.details.push(welfare);
                        const wagesYear = res.Year.details.shift();
                        const welfareYear = res.Year.details.shift();
                        res.Year.details.push(wagesYear);
                        res.Year.details.push(welfareYear);
                        this.monthData = res.Month;
                        this.yearData = res.Year;
                        if (res.Month && res.Year) {
                            this.$nextTick(function () {
                                this.drawMonthChart2();
                                this.drawYearChart();
                            });
                        }
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
        // 跳转到直接材料成本
        toCostDirectMaterials() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'costDirectMaterials',
                params: {
                    year: this.year,
                    month: this.month,
                    orgId: this.orgId,
                },
            });
        },


    },
    mounted() {
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        const obj = utils.getPreMon();
        this.year = obj.year;
        this.month = obj.month;
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
        const objTimeYear = localStorage.getItem('objTimeYear');
        const objTimeMonth = localStorage.getItem('objTimeMonth');
        this.year = objTimeYear || this.$route.query.year;
        this.month = objTimeMonth || this.$route.query.month;
        this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务生产成本情况';
        this.getCostsInfo();
    },
};
</script>

<style lang="stylus" scoped>
.cost-box
    padding-top 74rpx
    height calc(100% - 74rpx)
    .warpper
        height 100%
        overflow-x hidden
        overflow-y auto
        -webkit-overflow-scrolling touch
        .header
            width 100%
            height 30rpx
            background #F0F0F0
            font-size 12rpx
            text-align center
            line-height 30rpx
            .iconrili
                font-size 14rpx
                margin-right 6rpx
        .chart-title
            padding 15rpx 3% 10rpx
            font-size 16rpx
            position relative
            .subtitle
                float right
                color #979EA7
                font-size 10rpx
                padding-top 4rpx
        .split
            width 100%
            height 15rpx
            background #F0F0F0
        .utit-cost
            display flex
            height 68rpx
            .utit-cost-item
                flex 1
                text-align center
                .money
                    font-size 16rpx
                    margin 16rpx 0 5rpx 0
                .label
                    font-size 10rpx
                    color #666666
            .month-cost
                position relative
                .money
                    color #FA8436
                &:after
                    content ''
                    width 1px
                    height 15rpx
                    background #EAEAEA
                    position absolute
                    right 0
                    top 50%
                    margin-top -8rpx
            .year-cost
                .money
                    color #5588F1
        #monthPie
            width 100%
            height 225rpx
        #yearPie
            width 100%
            height 225rpx
        .btn-turn
            text-align center
            margin-bottom 10rpx
</style>